(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      var pista = raiz.querySelector('[data-pista]');
      if (!pista || pista.dataset.iniciado === 'true') return;
      pista.dataset.iniciado = 'true';

      var progreso = raiz.querySelector('[data-progreso]');
      var anterior = raiz.querySelector('[data-anterior]');
      var siguiente = raiz.querySelector('[data-siguiente]');

      function actualizar() {
        var maximo = pista.scrollWidth - pista.clientWidth;

        if (progreso) {
          var visible = pista.clientWidth / pista.scrollWidth;
          var ancho = Math.max(visible * 100, 12);
          var avance = maximo > 0 ? pista.scrollLeft / maximo : 0;
          progreso.style.width = ancho + '%';
          progreso.style.transform = 'translateX(' + (avance * (100 / ancho) * 100 - avance * 100) + '%)';
          progreso.style.left = (avance * (100 - ancho)) + '%';
          progreso.style.transform = 'none';
        }

        if (anterior) anterior.disabled = pista.scrollLeft <= 2;
        if (siguiente) siguiente.disabled = pista.scrollLeft >= maximo - 2;
      }

      function paso() {
        var tarjeta = pista.querySelector('.carrusel-colecciones__tarjeta');
        if (!tarjeta) return pista.clientWidth;
        var estilos = window.getComputedStyle(pista);
        var hueco = parseFloat(estilos.columnGap || estilos.gap || '0');
        return tarjeta.getBoundingClientRect().width + hueco;
      }

      if (anterior) {
        anterior.addEventListener('click', function () {
          pista.scrollBy({ left: -paso(), behavior: 'smooth' });
        });
      }

      if (siguiente) {
        siguiente.addEventListener('click', function () {
          pista.scrollBy({ left: paso(), behavior: 'smooth' });
        });
      }

      pista.addEventListener('scroll', function () {
        window.requestAnimationFrame(actualizar);
      });

      window.addEventListener('resize', actualizar);
      actualizar();
    }

    function iniciarTodos() {
      document.querySelectorAll('.carrusel-colecciones').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodos);
    } else {
      iniciarTodos();
    }

    document.addEventListener('shopify:section:load', iniciarTodos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valores"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(seccion) {
    if (seccion.dataset.carruselMovil !== 'true') return;

    var pista = seccion.querySelector('[data-valores-icon-pista]');
    var puntos = seccion.querySelectorAll('[data-valores-icon-punto]');
    if (!pista || !puntos.length) return;

    var slides = pista.querySelectorAll('[data-valores-icon-slide]');
    var temporizador = null;

    function indiceActivo() {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var mejor = 0;
      var menor = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var s = slides[i];
        var centroSlide = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(centroSlide - centro);
        if (d < menor) {
          menor = d;
          mejor = i;
        }
      }
      return mejor;
    }

    function actualizar() {
      var activo = indiceActivo();
      for (var i = 0; i < puntos.length; i++) {
        if (i === activo) {
          puntos[i].classList.add('valores-icon-punto-activo');
          puntos[i].setAttribute('aria-current', 'true');
        } else {
          puntos[i].classList.remove('valores-icon-punto-activo');
          puntos[i].removeAttribute('aria-current');
        }
      }
    }

    pista.addEventListener('scroll', function () {
      if (temporizador) window.cancelAnimationFrame(temporizador);
      temporizador = window.requestAnimationFrame(actualizar);
    }, { passive: true });

    for (var i = 0; i < puntos.length; i++) {
      puntos[i].addEventListener('click', function (evento) {
        var indice = parseInt(evento.currentTarget.getAttribute('data-valores-icon-punto'), 10);
        var destino = slides[indice];
        if (!destino) return;
        pista.scrollTo({
          left: destino.offsetLeft - (pista.clientWidth - destino.offsetWidth) / 2,
          behavior: 'smooth'
        });
      });
    }

    window.addEventListener('resize', actualizar, { passive: true });
    actualizar();
  }

  function iniciarTodo(raiz) {
    var secciones = (raiz || document).querySelectorAll('[data-valores-icon]');
    for (var i = 0; i < secciones.length; i++) {
      iniciarCarrusel(secciones[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodo(); });
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodo(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
